import { render, staticRenderFns } from "./ModuleDetailPage.vue?vue&type=template&id=1f9751e9&"
import script from "./ModuleDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ModuleDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleDetailPage.vue?vue&type=style&index=0&id=1f9751e9&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports